import { UrlStructure } from "types/UrlStructure";
import { UrlStructureItem } from "types/UrlStructureItem";

export const getUrlFromUrlStructureBySlug = (
  slug: string,
  array: UrlStructure,
): string | undefined => {
  return array?.urls?.find((arr: UrlStructureItem) => arr?.slug === slug)?.url;
};
